import { LoadingState } from '../../../shared/types/loading.type';

export const isLoadingStatus = (loadingStatus: LoadingState, status: LoadingState): boolean => {
  return loadingStatus === status;
};
